import React, { useState, useEffect } from 'react';
import brokenPlaces from '../../assets/images/brokenPlaces.webp'

const Card = ({ name, images, city, description }) => {
    const [currentImage, setCurrentImage] = useState(images[0]);
    const [isLoading, setIsLoading] = useState(true);

    const summarizedDescription = (description.substring(0, 57)) + "..."

    const checkImage = (url) => {
        return new Promise((resolve) => {
            const img = new Image();
            img.onload = () => resolve(true);
            img.onerror = () => resolve(false);
            img.src = url;
        });
    };

    useEffect(() => {
        (async () => {
            setIsLoading(true);
            const isImageCorrect = await checkImage(currentImage);
            if (!isImageCorrect) {
                setCurrentImage(brokenPlaces);
            }
            setIsLoading(false);
        })()
    }, [])



    return (
        <div className="card-container" >
            {!isLoading && <img
                className="images"
                src={currentImage}
                alt={city}
            />}

            <div className="texts-container">
                <div className="name">{name}</div>
                <div className="description">{summarizedDescription}</div>
            </div>
        </div>
    )
}

export default Card;